import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts/index";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index";
import OrdersHistoryPage from "../components/pages/order-history-page";

const OrdersHistory = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Orders History"
          pageDesc="List of all closed orders"
        >
          <OrdersHistoryPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default OrdersHistory;
